// NPM Imports
import React from "react";
import { connect } from "react-redux";

// Actions Imports
import { updateDocumentClickedComponentID } from "../../../actions/DocumentActions/index";

// Internals Imports
import { DOCUMENTS } from "../../../constants";

// Destructuring
const { DOCUMENT_LINE_SPACER_DATA } = DOCUMENTS;

class CustomLineSpace extends React.Component {
  customLineSpaceRef = React.createRef();

  componentDidMount() {
    if (
      this.customLineSpaceRef &&
      this.customLineSpaceRef.current &&
      this.props.isComponentActive
    ) {
      this.customLineSpaceRef.current.focus();
    }
  }

  // handle the selection of empty space heights (ex: 1x, 2x,3x)
  _selectLineSpace = selectedLineSpace => {
    const { handleBlur: updateSection, section } = this.props;
    if (section.data.length !== selectedLineSpace.length) {
      const newSection = { ...section };
      const newData = { ...newSection.data };
      newData.id = selectedLineSpace.id;
      newData.length = selectedLineSpace.length;
      newSection.data = newData;
      updateSection(newSection, undefined, undefined, section);
    }
  };

  _handleOnClick = event => {
    event.preventDefault();
    const { isComponentActive, isLocked, section } = this.props;
    if (!isLocked && !isComponentActive && section) {
      this.props.updateDocumentClickedComponentID(
        section.id,
        true,
        section.type,
      );
      this.props.createDocSectionRef(React.createRef());
    }
  };

  _handleOnBlur = event => {
    event.preventDefault();
    if (
      this.props.isComponentActive &&
      this.props.preventClickedComponentIdUpdate
    ) {
      this.props.updateDocumentClickedComponentID(null, true, null);
    }
  };

  render() {
    const {
      section: { data, lock },
      isLocked,
      isDocumentLocked,
      isComponentActive,
    } = this.props;
    let styles = {};
    if (data && data.length && data.unit) {
      styles = {
        height: `${data ? `${data.length}${data.unit}` : "50px"}`,
      };
    }
    const isSectionLocked = isDocumentLocked || isLocked || lock;
    return (
      <div
        ref={this.customLineSpaceRef}
        className={`customlinespace-component ${
          isComponentActive ? "active-customlinespace" : ""
        } `}
        style={styles}
        onClick={this._handleOnClick}
        onKeyPress={() => {}}
        onBlur={this._handleOnBlur}
        role="button"
        tabIndex={0}>
        <div className="customlinespace-text-wrapper">
          <span className="customlinespace-text">Empty space</span>
        </div>
        <div className="customlinespace-row linespace-selection-wrapper">
          {DOCUMENT_LINE_SPACER_DATA.map(lineSpacer => (
            <div
              className={`customlinespace-col ${
                !isSectionLocked ? " hover-col " : ""
              } ${data.id === lineSpacer.id ? " active " : ""}`}
              key={lineSpacer.label}
              onClick={
                isSectionLocked
                  ? () => {}
                  : () => this._selectLineSpace(lineSpacer)
              }
              onKeyPress={() => {}}
              tabIndex="0"
              role="button">
              {lineSpacer.label}
            </div>
          ))}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const { section } = props;
  // check if the section is in active state or hovered state
  const {
    clickedActiveComponentId,
    preventClickedComponentIdUpdate,
  } = state.DocumentStore;
  let isComponentActive = false;
  if (clickedActiveComponentId === section.id) isComponentActive = true;

  return {
    isComponentActive,
    preventClickedComponentIdUpdate,
  };
};

const mapDispatchToProps = {
  updateDocumentClickedComponentID,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CustomLineSpace);



// WEBPACK FOOTER //
// ./src/components/DocumentItems/CustomLineSpace/index.js